import { createTheme } from "@mui/material/styles";
//este e as pastas Entity e Routes tem codigos esclusivos deste app
export const configFirebase = {
    apiKey: "AIzaSyAKLZUx-F9RBfpqLxld9Ah_D3hLLVqan9k",
    authDomain: "appneloreproducao.firebaseapp.com",
    projectId: "appneloreproducao",
    storageBucket: "appneloreproducao.appspot.com",
    messagingSenderId: "870673603009",
    appId: "1:870673603009:web:ab11938fc867290d333740",
    measurementId: "G-XEKFKZ9FPG"
}

export const configFirebaseSecondary = {
    apiKey: "AIzaSyAKLZUx-F9RBfpqLxld9Ah_D3hLLVqan9k",
    authDomain: "appneloreproducao.firebaseapp.com",
    projectId: "appneloreproducao",
    storageBucket: "appneloreproducao.appspot.com",
    messagingSenderId: "870673603009",
    appId: "1:870673603009:web:ab11938fc867290d333740",
    measurementId: "G-XEKFKZ9FPG"
}

export const theme = createTheme({
    typography: {
        useNextVariants: true,
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        fontSize: 18,
    },
    palette: {
        primary: {
            main: "#2a440e",

            contrastText: "#fff",
        },
        secondary: {
            main: "#a6bd59",
            contrastText: "#000",
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
        },
        MuiButtonGroup: {
            defaultProps: {
                variant: "contained",
            },
        },
    },
});

export const themedark = createTheme({
    typography: {
        useNextVariants: true,
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        fontSize: 18,
    },

    palette: {
        mode: 'dark',
        background: {
            default: "#2a440e"
        },
        text: {
            primary: "#ffffff"
        },
        primary: {
            main: "#a6bd59",
            contrastText: "#000",
        },
        secondary: {
            main: "#519903",
            contrastText: "#fff",
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
        },
        MuiButtonGroup: {
            defaultProps: {
                variant: "contained",
            },
        },
        MuiInput: {
            styleOverrides: {
                input: {
                    colorScheme: 'dark',                
                },
              },
        }
    },


});